//ga link decorator used for onclick buttons (see below)
function dEdgeBookingDecoration(url, target) {

    //Universal analytics decorator
    if (typeof ga !== 'undefined' && typeof ga.getAll === 'function') {
        try {
            var trackers = ga.getAll();
            if (trackers.length) {
                linker = new window.gaplugins.Linker(trackers[0]);
                url = linker.decorate(url);
            }
        } catch (e) {
            // Do nothing. Bloody ad blockers.
        }
    }

    //Google Analytics 4 decorator
    if (typeof _GA4CrossDomain !== 'undefined' && typeof _GA4CrossDomain.decorateURL === 'function') {
        try {
            url = _GA4CrossDomain.decorateURL(url);
        } catch (e) {
            // Do nothing. Bloody ad blockers.
        }
    }

    return window.open(url, target);
}

function convertWebSDKOffer(original, config) {

    if (typeof original.rate.image !== 'undefined') {
        var offer_image = original.rate.image.url;
        var offer_class = '';
    } else {
        //we add a transparent 1x1 png, if the offers has no image; also we add a helper class
        offer_image = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
        offer_class = ' no_image_available ';
    }
    //js onclick link doesn't work for AVP, so we polyfill it here

    if (typeof _GA4CrossDomain !== 'undefined' && typeof _GA4CrossDomain.decorateURL === 'function') {
        try {
            waction = _GA4CrossDomain.decorateURL(waction);
        } catch (e) {
            // Do nothing. Bloody ad blockers.
        }
    }

    onclickFirst = 'dEdgeBookingDecoration(' + JSON.stringify(original.firstAvailDate.plainBookLink) + ', \'_blank\')';
    onclickBest = 'dEdgeBookingDecoration(' + JSON.stringify(original.quotation.plainBookLink) + ', \'_blank\')';

    //check if accessCode exists
    rateName = original.rate.name;
    accessCode = typeof original.rate.distribution.accessCode !== 'undefined' ? original.rate.distribution.accessCode[0] : rateName;

    //a couple of helper classes to add to the most external container
    offer_class += 'code__' + accessCode.replace(/\s+/g, '-');
    offer_class += ' id__' + rateName.replace(/\s+/g, '-');

    //default value of a flag used to order the rates via CMS
    order = 9999;

    //overriding the order flag according to value coming from the CMS
    if (typeof config.sorting !== 'undefined' && config.sorting !== null) {
        config.sorting.forEach(function (element, index) {
            //for CMS users convenience we allow to use both access code and offer id
            var matchAccessCode = accessCode === element.replace(/\s+/g, '');
            var matchOfferId = rateName === element.replace(/\s+/g, '');
            if (matchAccessCode || matchOfferId) {
                order = index;
            }
        })
    }

    return {
        _orig: original,
        websdk: true,
        rate: {
            id: rateName,
            code: accessCode,
            title: original.rate.title,
            order: order,
            class: offer_class,
            image: offer_image,
            desc: {
                html: original.rate.html_description,
                plain: original.rate.plain_description,
                exerpt: original.rate.plain_description.substr(0, 150) + '&hellip;',
            }
        },
        best: {
            bookLink: {
                js: original.quotation.jsBookLink,
                onclick: onclickBest,
                url: original.quotation.plainBookLink,
            },
            pricePerNight: original.quotation.pricePerNight,
            currency: original.quotation.currency,
            currency_html: original.quotation.currency_html,
            room: original.quotation.room,
            totalPrice: original.quotation.totalPrice,
            from: original.quotation.bookingParams.from,
            to: original.quotation.bookingParams.to,
            nights: original.quotation.bookingParams.nbNight,
            pricePerNightSplitted: {
                thousands: original.quotation.pricePerNightSplitted.thousands,
                decimals: original.quotation.pricePerNightSplitted.decimals
            }
        },
        first: {
            from: original.firstAvailDate.bookingParams.from,
            fromYYMMDD: original.firstAvailDate.bookingParams.fromYYMMDD,
            to: original.firstAvailDate.bookingParams.to,
            toYYMMDD: original.firstAvailDate.bookingParams.toYYMMDD,
            nights: original.firstAvailDate.bookingParams.nbNight,
            bookLink: {
                js: original.firstAvailDate.jsBookLink,
                onclick: onclickFirst,
                url: original.firstAvailDate.plainBookLink
            }
        }
    }
}


